<template>
  <qx-card title="备注信息">
    <qx-img-dialog ref="imgDialog" />
    <qx-detail-box :data="detailData.base">
      <section slot="settlementDetail">
        <DetailItem
          :detailItemList="settlementDetailItemList"
          :orderDetail="orderDetail"
          propName="settlementDetail"
        />
      </section>

      <section slot="belongDetail">
        <DetailItem
          :detailItemList="belongDetailItemList"
          :orderDetail="orderDetail"
          propName="belongDetail"
        />
      </section>

      <section slot="costDetail">
        <div class="detail-item-inline-box">
          <div
            class="detail-item-horizontal"
            v-for="(item, index) in costDetailItemList"
            :key="index"
          >
            <DetailItem
              :detailItemList="item"
              :orderDetail="orderDetail"
              :moneyTypeList="moneyTypeList"
              propName="costDetail"
              :detailItemHorizontal="true"
            />
          </div>
        </div>
      </section>

      <section slot="enclosureDetail">
          <DetailItem
            :detailItemList="enclosureDetailItemList"
            :orderDetail="orderDetail"
            propName="enclosureDetail"
          />

      </section>

      <!--      司机油/气耗费用审核-->
      <section slot="oilConsumptionDetail">
        <div class="detail-item-inline-box">
          <div
              class="detail-item-horizontal"
              v-for="(item, index) in oilConsumptionDetailItemList"
              :key="index"
          >
            <DetailItem
                :detailItemList="item"
                :orderDetail="orderDetail"
                propName="oilConsumptionDetail"
                :detailItemHorizontal="false"
            />
            <span class="grid-content bg-purple-light" style="color:green" v-show="oilData.auditStatus===0">审核状态：通过</span>
            <span class="grid-content bg-purple-light" style="margin-right: 15px" v-show="oilData.auditStatus===1">审核状态：不通过</span>
            <span class="grid-content bg-purple-light" style="margin-right: 15px" v-show="oilData.auditStatus===2">审核状态：待审核</span>
            <span class="primary cur"
                  style="margin-right: 15px"
                  v-show="isVerity==1 && oilData.auditStatus===2"
                  @click="showOilApprove(oilData)"
            >审核</span>
            <span class="primary cur"
                  style="margin-left: 5px"
                  v-show="isVerity==1"
                  v-if="(detailRes.orderScheduler.carDriverId && detailRes.orderInfoExt.driverBasealaryDouble!==0)
                        ||(detailRes.orderScheduler.copilotUserId && detailRes.orderInfoExt.coDriverBasealaryDouble!==0)"
                  @click="showOilModify(oilData)"
            >上传</span>
          </div>
        </div>
        <oilApproveDialog
            ref="oilApproveDialog"
            @sub="oilApproveSuccess"
        />
        <oilModidyDialog
            ref="oilModifyDialog"
            @sub="oilModifySuccess"
        />
      </section>

      <!-- 预支/借支款费用审核-->
      <section slot="changefitDetail" style="padding: 10px 0px">
        <div class="changeFitBox">
          <el-row>
            <el-col :span="5" class="th_1"><span class="grid-content bg-purple">&nbsp;</span></el-col>
            <el-col :span="5" class="th_1" ><span class="grid-content bg-purple-light">预支/借支款金额</span></el-col>
            <el-col :span="4" class="th_1"><span class="grid-content bg-purple">实际支出</span></el-col>
            <el-col :span="4" class="th_1"><span class="grid-content bg-purple-light">审核状态</span></el-col>
            <el-col :span="6" class="th_1">
              <span class="primary cur grid-content bg-purple-light" @click="toFastAudit(moneyTypeList)" v-show="isVerity==1 && moneyTypeList.length!==0"
              >一键审核</span>
            </el-col>
          </el-row>
          <el-row v-for="(item,index) in moneyTypeList" :key="index">
            <el-col :span="6" class="td_1">
              <el-popover
                  placement="top-start"
                  title=""
                  width="200"
                  trigger="hover"
                  :content="item.moneyTypeName">
                <span slot="reference" v-if="item.moneyTypeName.length>10">
                  <span>{{item.moneyTypeName}}</span>
                </span>
              </el-popover>
              <span>{{item.moneyTypeName}}</span>
              <span>{{'：'}}</span>
<!--              <div class="grid-content bg-purple label">{{ item.moneyTypeName +'：' }}</div>-->
            </el-col>
            <el-col :span="4" class="td_2">
              <div class="grid-content bg-purple-light">
              {{ item.moneyTypeValueDouble }}

              </div>
            </el-col>
            <el-col :span="4" class="td_2">
              <div class="grid-content bg-purple" v-if="item.auditingStatus===2">{{ item.moneyValuePayDouble?item.moneyValuePayDouble:'--'}}</div>
              <div class="grid-content bg-purple" v-else>{{ item.moneyValuePayDouble}}</div>
            </el-col>
            <el-col :span="4" class="td_2">
              <div class="grid-content bg-purple-light" style="color:green" v-show="item.auditingStatus===0">通过</div>
              <div class="grid-content bg-purple-light warning" v-show="item.auditingStatus===1">不通过</div>
              <div class="grid-content bg-purple-light primary" v-show="item.auditingStatus===2">未上传</div>
              <div class="grid-content bg-purple-light warning" v-show="item.auditingStatus===3">待审核</div>
            </el-col>
            <el-col :span="6">
              <span class="primary cur"
                    v-show="isVerity==1&&item.auditingStatus===3"
                    @click="showDriveApprove(item)"
              >审核</span>
              <span class="primary cur"
                    style="margin-left: 5px"
                    v-show="isVerity==1"
                    v-if="(detailRes.orderScheduler.carDriverId && detailRes.orderInfoExt.driverBasealaryDouble!==0)
                          ||(detailRes.orderScheduler.copilotUserId && detailRes.orderInfoExt.coDriverBasealaryDouble!==0)"
                    @click="showDriveModify(item)"
              >上传</span>
            </el-col>
            <span class="error-info error"></span>
          </el-row>
        </div>
<!--        <div class="" style="display: inline-block;margin-left: 10px">-->
<!--          <el-row>-->
<!--            <el-col :span="24" class="th_1"><span class="grid-content bg-purple">&nbsp;</span></el-col>-->
<!--          </el-row>-->
<!--          <el-row v-for="(item,index) in moneyTypeList" :key="index">-->
<!--            <el-col :span="24" class="error-info error"><div class="grid-content bg-purple label">预估支出修改为</div></el-col>-->

<!--            <span class="error-info error"></span>-->
<!--          </el-row>-->
<!--        </div>-->
        <DriveApproveDialog
            ref="driveApproveDialog"
            @sub="driveApproveSuccess"
        />
        <DriveModidyDialog
            ref="driveModifyDialog"
            @sub="driveModifySuccess"
        />
      </section>

      <!--      利润-->
      <section slot="profitDetail">
<!--        <DetailItem-->
<!--          :detailItemList="profitDetailItemList"-->
<!--          :moneyTypeList="moneyTypeList"-->
<!--          :orderDetail="orderDetail"-->
<!--          propName="profitDetail"-->
<!--        />-->
        <div class="detail-item-inline-box">
          <div
              class="detail-item-horizontal"
              v-for="(item, index) in profitDetailItemList"
              :key="index"
          >
            <DetailItem
                :detailItemList="item"
                :orderDetail="orderDetail"
                :moneyTypeList="moneyTypeList"
                propName="profitDetail"
                :detailItemHorizontal="true"
            />
          </div>
        </div>
      </section>

      <section slot="otherDetail">
        <DetailItem
          :detailItemList="otherDetailItemList"
          :orderDetail="orderDetail"
          propName="otherDetail"
        />
      </section>
    </qx-detail-box>
  </qx-card>
</template>

<script>
import {floatSub} from '@qx/utils';
import {getOilConsumptionByOrderId, saveOrderMoneyTypeVerifyResult, getOperInteCfgResultInfo, getGasConsumptionByOrderId} from 'api/operate';
import {getAllVehicleInfo} from 'api/car';
import DetailItem from './components/detailItem';
import DriveApproveDialog from './components/driveApproveDialog';
import DriveModidyDialog from './components/driveModifyDialog';
import oilApproveDialog from './components/oilApproveDialog';
import oilModidyDialog from './components/oilModifyDialog';

export default {
  components: {
    DetailItem,
    DriveApproveDialog,
    DriveModidyDialog,
    oilApproveDialog,
    oilModidyDialog,
  },
  props: {
    orderId: {
      type: String,
    },
  },
  data () {
    return {
      isVerity: '',
      orderDetail: {},
      oilData: {},
      moneyTypeList: [],
      isShowChangefitDetail: true,
      orderFieldAliasMap: {},
      settlementDetailItemList: [
        { label: '结算方式', value: 'balanceTypeName' },
        { label: '回单期限', value: 'reciveTime' },
        { label: '付款期限', value: 'collectionTime' },
      ],
      belongDetailItemList: [
        { label: '跟单人员', value: 'localUserName' },
        { label: '跟单手机', value: 'localPhone' },
        { label: '归属部门', value: 'orgIdName' },
        { label: '司机是否隐藏跟单人员', value: 'visibleTrace' },
      ],
      costDetailItemList: [],
      oilConsumptionDetailItemList: [],
      profitDetailItemList: [],
      enclosureDetailItemList: [
        { label: '承运合同', value: 'contractUrl', type: 'img' },
      ],
      otherDetailItemList: [
        { label: '备注说明', value: 'remark' },
      ],
      detailRes: {},
      detailData: {
        base: {
          label: '',
          tableData: {
            title: [
              {
                prop: 'settlementDetail',
                label: '结算方式',
                slot: true,
                span: 1,
              },
              {
                prop: 'belongDetail',
                label: '归属',
                slot: true,
                span: 1,
              },
              // {
              //   prop: 'costDetail',
              //   label: '成本',
              //   slot: true,
              //   span: 1,
              // },
              // {
              //   prop: 'oilConsumptionDetail',
              //   label: '司机油/气耗费用',
              //   slot: true,
              //   span: 1,
              // },
              // {
              //   prop: 'changefitDetail',
              //   label: '预支/借支款费用审核',
              //   slot: true,
              //   span: 1,
              // },
              // {
              //   prop: 'profitDetail',
              //   label: '利润',
              //   slot: true,
              //   span: 1,
              // },
              {
                prop: 'enclosureDetail',
                label: '附件',
                slot: true,
                span: 1,
              },
              {
                prop: 'otherDetail',
                label: '其他',
                slot: true,
                span: 1,
              },
            ],
            data: {
            },
            approveData: {
            },
          },
        },
      },
    };
  },
  computed: {
    colSpan () {
      const total = 24;
      const minSpan = 4;
      return parseInt(total / this.orderInfo.length, 10) < minSpan ? minSpan : parseInt(total / this.orderInfo.length, 10);
    },
  },
  methods: {
    showImg (url) {
      this.$refs.imgDialog.show(url);
    },
    // 审核出车打款弹框
    showDriveApprove (item) {
      this.$refs.driveApproveDialog.show(item);
    },
    // 预支/借支款金额修改弹框
    showDriveModify (item) {
      this.$refs.driveModifyDialog.show(item);
    },
    driveApproveSuccess () {
      this.$emit('load');
    },
    driveModifySuccess () {
      this.$emit('load');
    },
    // 审核司机油/气耗费用弹框
    showOilApprove (item) {
      this.$refs.oilApproveDialog.show(item, this.detailRes);
    },
    // 司机油/气耗费用修改弹框
    showOilModify (item) {
      this.$refs.oilModifyDialog.show(item, this.detailRes);
    },
    oilApproveSuccess () {
      this.$emit('load');
    },
    oilModifySuccess () {
      this.$emit('load');
    },
    // 一键审核出车打款费用
    async toFastAudit (moneyTypeList) {
      let id = [];
      if (moneyTypeList) {
        moneyTypeList.map((item) => {
          id.push(item.id);
        });
      }
      let orderId = moneyTypeList[0].orderId;
      const confirmRes = await this.$confirm('确定要一键审核通过吗？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => {
        // 取消操作
      });
      let formData = null;
      if (confirmRes === 'confirm') {
        formData = {

          id: id.toString(','),
          orderId: orderId,
          auditingStatus: 0, // 审核通过传0 不通过传1
          opinion: '',

        };
        const res = await saveOrderMoneyTypeVerifyResult(formData);
        if (!res.failed) {
          this.$message({
            type: 'success',
            message: '操作成功',
          });
          this.$emit('load');
        }
      }
    },
    // 详情数据（用来展示）
    async setBaseData (detailRes, oilRes) {
      const orderGoods = detailRes.orderGoods;
      const orderInfo = detailRes.orderInfo;
      const costPaymentDaysInfo = detailRes.costPaymentDaysInfo || {};
      const costDetail = this.getCostDetailData(detailRes, true);
      this.syncChangefitDetail(detailRes);
      const profitDetail = this.getProfitDetailData(detailRes);
      const oilConsumptionDetail = this.getoilConsumptionDetailData(detailRes, oilRes);

      this.orderDetail.base = {
        ...this.orderDetail.base,
        settlementDetail: this.getSettlementDetailData(costPaymentDaysInfo),
        belongDetail: this.getBelongDetailData(orderInfo, orderGoods),
        costDetail,
        profitDetail,
        oilConsumptionDetail,
        enclosureDetail: this.getEnclosureDetail(orderGoods),
        otherDetail: this.getOtherDetail(orderInfo),
        paymentWayName: detailRes.orderInfoExt.paymentWayName,
        paymentWay: detailRes.orderInfoExt.paymentWay,

      };
      this.detailData.base.tableData.data = this.orderDetail.base;
      this.moneyTypeList = detailRes.orderMoneyType || [];
    },
    // 获取车辆信息
    async getCarInfo (data) {
      // vehicleCode
      return getAllVehicleInfo({
        vehicleCode: data.vehicleCode,
      });
    },
    // 审核数据（用来和 详情数据 做对比，如果和 详情数据不一样，则提示）
    setBaseVerData (detailRes) {

      const orderGoods = detailRes.orderGoodsVer;
      const orderInfo = detailRes.orderInfoVer;
      const costPaymentDaysInfo = detailRes.costPaymentDaysInfoVer || {};

      this.orderDetail.baseVer = {
        ...this.orderDetail.baseVer,
        settlementDetail: this.getSettlementDetailData(costPaymentDaysInfo),
        belongDetail: this.getBelongDetailData(orderInfo, orderGoods),
        costDetail: this.getCostDetailData(detailRes),
        profitDetail: this.getProfitDetailData(detailRes),
        enclosureDetail: this.getEnclosureDetail(orderGoods),
        otherDetail: this.getOtherDetail(orderInfo),
        paymentWayName: detailRes.orderInfoExt.paymentWayName,
      };

      this.detailData.base.tableData.approveData = this.orderDetail.baseVer;
      this.moneyTypeList = detailRes.orderMoneyType || [];
    },
    getSettlementDetailData (costPaymentDaysInfo) {
      const costDetail = {
        balanceType: costPaymentDaysInfo.balanceType,
        balanceTypeName: costPaymentDaysInfo.balanceTypeName,
      };
      if (costPaymentDaysInfo.balanceType === 1) {
        // 预付全款
        costDetail['reciveTime'] = `${costPaymentDaysInfo.reciveTime}天`;
        costDetail['collectionTime'] = '';
      } else if (costPaymentDaysInfo.balanceType === 2) {
        // 预付 + 尾款结账 回单期限：x天 付款期限：x天
        costDetail['reciveTime'] = `${costPaymentDaysInfo.reciveTime}天`;
        costDetail['collectionTime'] = `${costPaymentDaysInfo.collectionTime}天`;
      } else if (costPaymentDaysInfo.balanceType === 3) {
        // 预付 + 尾款月结 回单期限：x月后x号 付款期限：x月后x号
        costDetail['reciveTime'] = `${costPaymentDaysInfo.reciveMonth || '-'}个月后${costPaymentDaysInfo.reciveDay || '-'}号`;
        costDetail['collectionTime'] = `${costPaymentDaysInfo.collectionMonth || '-'}个月后${costPaymentDaysInfo.collectionDay || '-'}号`;
      }
      return costDetail;
    },
    getBelongDetailData (orderInfo, orderGoods) {
      return {
        localUserName: orderGoods.localUserName,
        localPhone: orderGoods.localPhone,
        orgIdName: orderInfo.orgIdName,
        visibleTrace: orderGoods.visibleTrace === -1 ? '--' : (orderGoods.visibleTrace === 1 ? '是' : '否'),
      };
    },
    getCostDetailData (detailRes, isBaseData) {
      const costDetail = {
        totalCost: (detailRes.totalCost / 100).toFixed(2) + '元',
        operCost: (detailRes.operCost / 100).toFixed(2) + '元',
        changeCost: (detailRes.changeCost / 100).toFixed(2) + '元',
        fixedCost: (detailRes.fixedCost / 100).toFixed(2) + '元',
      };

      if (isBaseData) {
        // 根据索引找到 成本信息 ，先删除，避免重复生成，根据判断条件再添加回来
        const index = this.detailData.base.tableData.title.findIndex((item) => item.prop === 'costDetail');
        if (index !== -1) {
          // 如果已存在，先删除
          this.detailData.base.tableData.title.splice(index, 1);
        }
        if (detailRes.orderCostPermission) {
          // 添加回来，展示 各种成本信息
          const insertIndex = this.detailData.base.tableData.title.findIndex((item) => item.prop === 'belongDetail') + 1;
          this.detailData.base.tableData.title.splice(insertIndex, 0, {
            prop: 'costDetail',
            label: '成本',
            slot: true,
            span: 1,
          });
          this.costDetailItemList.length = 0;
          this.costDetailItemList.push([
            { label: '总成本', value: 'totalCost' },
            { label: '直接成本', value: 'operCost' },
            { label: '变动成本', value: 'changeCost' },
            { label: '固定成本', value: 'fixedCost' },
          ]);
          if (Number(detailRes.orderInfoExt.paymentWay) === 2) {
            // 展示 各种里程 和 耗油 和 校准空载里程 和 校准载重里程
            this.costDetailItemList.push(
              [
                { label: '空载里程', value: 'emptyRunDistance' },
                { label: '载重里程', value: 'runDistance' },
                { label: '订单耗时', value: 'orderTotalTime' },
                { label: '总耗油', value: 'oilWearTotal' },
                { label: '订单油耗', value: 'orderOilWear' },
              ],
              [
                { label: '校准空载里程', value: 'checkEmptyRunDistance' },
                { label: '校准载重里程', value: 'checkRunDistance' },
              ],
            );
          }
        }
      }

      if (Number(detailRes.orderInfoExt.paymentWay) === 2) {
        const orc = detailRes.orderRetrographyCostInfo;
        if (orc) {
          const emptyRunDistance = orc.emptyRunDistance;
          const runDistance = orc.runDistance;
          const orderTotalTime = orc.orderTotalTime;
          const oilWearTotal = orc.oilWearTotal;
          const oilFeeTotal = orc.oilFeeTotal;
          const orderOilWear = orc.orderOilWear;
          const checkEmptyRunDistance = orc.checkEmptyRunDistance;
          const checkRunDistance = orc.checkRunDistance;

          costDetail.emptyRunDistance = (emptyRunDistance !== null ? ((emptyRunDistance / 1000).toFixed(2)) : '--') + 'KM';
          costDetail.runDistance = (runDistance !== null ? ((runDistance / 1000).toFixed(2)) : '--') + 'KM';
          costDetail.orderTotalTime = (orderTotalTime !== null ? ((orderTotalTime / 100).toFixed(2)) : '--') + '小时';
          costDetail.oilWearTotal =
            ((oilWearTotal !== null ? ((oilWearTotal / 100).toFixed(2)) : '--') + '升 / ') +
            ((oilFeeTotal !== null ? ((oilFeeTotal / 100).toFixed(2)) : '--')) + '元';
          costDetail.orderOilWear = (orderOilWear !== null ? ((orderOilWear / 100).toFixed(2)) : '--') + '升/百公里';
          costDetail.checkEmptyRunDistance = (checkEmptyRunDistance !== null ? ((checkEmptyRunDistance / 1000).toFixed(2)) : '--') + 'KM';
          costDetail.checkRunDistance = (checkRunDistance !== null ? ((checkRunDistance / 1000).toFixed(2)) : '--') + 'KM';
        }
      }
      return costDetail;
    },
    getoilConsumptionDetailData (detailRes, oilRes) {
      let oilSubsidyScaleMainStr;
      let coOilSubsidyScaleMainStr;
      let gasSubsidyScaleMainDouble;
      let coGasSubsidyScaleMainDouble;
      let _haveRemark = !!detailRes.orderScheduler.copilotUserId && Number(detailRes.orderScheduler.vehicleClass) === 1 && !!detailRes.vehicleInfo.remark && detailRes.vehicleInfo.remark.indexOf('外包') <= -1;
      let _noHaveRemark = !!detailRes.orderScheduler.copilotUserId && Number(detailRes.orderScheduler.vehicleClass) === 1 && !detailRes.vehicleInfo.remark;
      if (oilRes === '') {
        if (_haveRemark || _noHaveRemark) {
          // oilSubsidyScaleMainStr = 50;
          // coOilSubsidyScaleMainStr = 50;
          oilSubsidyScaleMainStr = 100;
          coOilSubsidyScaleMainStr = 0;
          gasSubsidyScaleMainDouble = 100;
          coGasSubsidyScaleMainDouble = 0;
        } else if (detailRes.orderInfoExt.reportingRole === 0 || detailRes.orderInfoExt.reportingRole === null) {
          oilSubsidyScaleMainStr = 100;
          coOilSubsidyScaleMainStr = 0;
          gasSubsidyScaleMainDouble = 100;
          coGasSubsidyScaleMainDouble = 0;
        } else {
          oilSubsidyScaleMainStr = 0;
          coOilSubsidyScaleMainStr = 100;
          gasSubsidyScaleMainDouble = 0;
          coGasSubsidyScaleMainDouble = 100;
        }
      } else {
        oilSubsidyScaleMainStr = oilRes.oilSubsidyScaleMainStr;
        coOilSubsidyScaleMainStr = oilRes.coOilSubsidyScaleMainStr;
        gasSubsidyScaleMainDouble = oilRes.gasSubsidyScaleMainDouble;
        coGasSubsidyScaleMainDouble = floatSub(100, oilRes.gasSubsidyScaleMainDouble);
      }
      let oilConsumptionDetail;
      if (this.isOilEnergy(detailRes, oilRes)) {
        oilConsumptionDetail = {
          kilometreDouble: oilRes !== '' ? oilRes.kilometreDouble + 'KM' : '',
          actualOilConsumptionDouble: oilRes !== '' ? oilRes.actualOilConsumptionDouble + '升' : '',
          standardOilConsumptionDouble: oilRes !== '' ? oilRes.standardOilConsumptionDouble + '升' : '',
          standardRiseDouble: oilRes !== '' ? oilRes.standardRiseDouble + 'L' : '',
          oilRiseDouble: oilRes !== '' ? oilRes.oilRiseDouble + 'L' : '',
          surplusRiseDouble: oilRes !== '' ? oilRes.surplusRiseDouble + 'L' : '',
          oilSubsidyDouble: oilRes !== '' ? oilRes.oilSubsidyDouble + '元' : '',
          mainDriverSubsidyDouble: oilRes !== '' ? oilRes.mainDriverSubsidyDouble + '元' : '',
          coDriverSubsidyDouble: oilRes !== '' ? oilRes.coDriverSubsidyDouble + '元' : '',
          startingKilometerUrl: oilRes !== '' && oilRes.startingKilometerUrl ? oilRes.startingKilometerUrl.split(',') : '',
          endKilometerUrl: oilRes !== '' && oilRes.endKilometerUrl ? oilRes.endKilometerUrl.split(',') : '',
          oilRiseImgUrl: oilRes !== '' && oilRes.oilRiseImgUrl ? oilRes.oilRiseImgUrl.split(',') : '',
          oilSubsidyScaleMainStr: oilSubsidyScaleMainStr + '%',
          coOilSubsidyScaleMainStr: coOilSubsidyScaleMainStr + '%',
        };
      } else if (detailRes.energyType === 'E') {
        oilConsumptionDetail = {
          kilometreDouble: oilRes !== '' && oilRes.kilometreDouble !== null && oilRes.kilometreDouble !== undefined ? oilRes.kilometreDouble + 'KM' : '',
          standardConsPerKiloDouble: oilRes !== '' && oilRes.standardConsPerKiloDouble !== null ? oilRes.standardConsPerKiloDouble + 'KG' : '',
          standardGasInjectionVolumeDouble: oilRes !== '' && oilRes.standardGasInjectionVolumeDouble !== null ? oilRes.standardGasInjectionVolumeDouble + 'KG' : '',
          actualConsPerKiloDouble: oilRes !== '' && oilRes.actualConsPerKiloDouble !== null ? oilRes.actualConsPerKiloDouble + 'KG' : '',
          actualGasInjectionVolumeDouble: oilRes !== '' ? oilRes.actualGasInjectionVolumeDouble + 'KG' : '',
          surplusGasVolumeDouble: oilRes !== '' && oilRes.surplusGasVolumeDouble !== null ? oilRes.surplusGasVolumeDouble + 'KG' : '',
          gasSubsidyDouble: oilRes !== '' && oilRes.gasSubsidyDouble !== null ? oilRes.gasSubsidyDouble + '元' : '',
          mainDriverGasSubsidyDouble: oilRes !== '' && oilRes.mainDriverGasSubsidyDouble !== null ? oilRes.mainDriverGasSubsidyDouble + '元' : '',
          gasSubsidyScaleMainDouble: gasSubsidyScaleMainDouble + '%',
          coDriverGasSubsidyDouble: oilRes !== '' && oilRes.coDriverGasSubsidyDouble !== null ? oilRes.coDriverGasSubsidyDouble + '元' : '',
          coGasSubsidyScaleMainDouble: coGasSubsidyScaleMainDouble + '%',
          startingKilometerImgUrl: oilRes !== '' && oilRes.startingKilometerImgUrl ? oilRes.startingKilometerImgUrl.split(',') : '',
          endKilometerImgUrl: oilRes !== '' && oilRes.endKilometerImgUrl ? oilRes.endKilometerImgUrl.split(',') : '',
          gasFillingQuantityImgUrl: oilRes !== '' && oilRes.gasFillingQuantityImgUrl ? oilRes.gasFillingQuantityImgUrl.split(',') : '',

        };
      }
      // 根据索引找到 ”司机油/气耗费用“模块信息 ，先删除，避免重复生成，根据判断条件再添加回来
      const index = this.detailData.base.tableData.title.findIndex((item) => item.prop === 'oilConsumptionDetail');
      if (index !== -1) {
        // 如果已存在，先删除
        this.detailData.base.tableData.title.splice(index, 1);
      }
      // 司机油/气耗费用排在预支/借支款后；未展示该模块时，排在利润或成本后
      const changefitIndex = this.detailData.base.tableData.title.findIndex((item) => item.prop === 'changefitDetail');
      const profitIndex = this.detailData.base.tableData.title.findIndex((item) => item.prop === 'profitDetail');
      const costIndex = this.detailData.base.tableData.title.findIndex((item) => item.prop === 'costDetail');
      const anchorIndex = changefitIndex !== -1 ? changefitIndex : (profitIndex !== -1 ? profitIndex : costIndex);
      const insertIndex = anchorIndex + 1;
      if (this.isOrderPaymentWay(detailRes.orderInfoExt)) {
        this.detailData.base.tableData.title.splice(insertIndex, 0, {
          prop: 'oilConsumptionDetail',
          label: '司机油/气耗费用',
          slot: true,
          span: 1,
        });
      }
      this.oilConsumptionDetailItemList.length = 0;
      if (this.isOilEnergy(detailRes, oilRes)) {
        this.oilConsumptionDetailItemList.push([
          { label: '运输公里数', value: 'kilometreDouble' },
          { label: '每公里实际消耗', value: 'actualOilConsumptionDouble' },
          { label: '每公里规定标准', value: 'standardOilConsumptionDouble' },
          { label: '规定燃油量', value: 'standardRiseDouble' },
          { label: '实际加油升数', value: 'oilRiseDouble' },
          { label: '结余数量', value: 'surplusRiseDouble' },
          { label: '本趟油补', value: 'oilSubsidyDouble' },
          { label: '主驾油补', value: 'mainDriverSubsidyDouble' },
          { label: '主驾油补比例', value: 'oilSubsidyScaleMainStr' },
          { label: '副驾油补', value: 'coDriverSubsidyDouble' },
          { label: '副驾油补比例', value: 'coOilSubsidyScaleMainStr' },
          { label: '起始公里数', value: 'startingKilometerUrl', type: 'img' },
          { label: '终点公里数', value: 'endKilometerUrl', type: 'img' },
          { label: '加油升数', value: 'oilRiseImgUrl', type: 'img' },
        ]);
      } else if (detailRes.energyType === 'E') {
        this.oilConsumptionDetailItemList.push([
          { label: '运输公里数', value: 'kilometreDouble' },
          { label: '每公里规定标准', value: 'standardConsPerKiloDouble' },
          { label: '每公里实际消耗', value: 'actualConsPerKiloDouble' },
          { label: '规定燃气量', value: 'standardGasInjectionVolumeDouble' },
          { label: '实际加气量', value: 'actualGasInjectionVolumeDouble' },
          { label: '结余气量', value: 'surplusGasVolumeDouble' },
          { label: '本趟气补', value: 'gasSubsidyDouble' },
          { label: '主驾气补', value: 'mainDriverGasSubsidyDouble' },
          { label: '主驾气补比例', value: 'gasSubsidyScaleMainDouble' },
          { label: '副驾气补', value: 'coDriverGasSubsidyDouble' },
          { label: '副驾气补比例', value: 'coGasSubsidyScaleMainDouble' },
          { label: '起始公里数', value: 'startingKilometerImgUrl', type: 'img' },
          { label: '终点公里数', value: 'endKilometerImgUrl', type: 'img' },
          { label: '加气数量', value: 'gasFillingQuantityImgUrl', type: 'img' },
        ]);
      }
      return oilConsumptionDetail;
    },
    getProfitDetailData (detailRes) {
      const profitDetail = {
        carPrepayMoney: detailRes.orderInfoExt.carPrepayMoneyDouble,
        driverBasealary: detailRes.orderInfoExt.driverBasealaryDouble,
        coDriverBasealary: detailRes.orderInfoExt.coDriverBasealaryDouble,
        estimateProfitDouble: detailRes.estimateProfitDouble,
        actualProfitDouble: detailRes.actualProfitDouble,
      };
      // 根据索引找到 利润信息 ，先删除，避免重复生成，根据判断条件再添加回来
      const index = this.detailData.base.tableData.title.findIndex((item) => item.prop === 'profitDetail');
      if (index !== -1) {
        // 如果已存在，先删除
        this.detailData.base.tableData.title.splice(index, 1);
      }
      // 利润展示只依赖订单模式和成本查看权限，不应依赖预支/借支款配置
      const changefitIndex = this.detailData.base.tableData.title.findIndex((item) => item.prop === 'changefitDetail');
      const costIndex = this.detailData.base.tableData.title.findIndex((item) => item.prop === 'costDetail');
      const insertIndex = (changefitIndex !== -1 ? changefitIndex : costIndex) + 1;
      if (this.isOrderPaymentWay(detailRes.orderInfoExt) && detailRes.orderCostPermission) {
        this.detailData.base.tableData.title.splice(insertIndex, 0, {
          prop: 'profitDetail',
          label: '利润',
          slot: true,
          span: 1,
        });
      }
      this.profitDetailItemList.length = 0;
      // 没有副驾基本服务费就不展示该字段
      if (detailRes.orderInfoExt.coDriverBasealary === null) {
        this.profitDetailItemList.push([
          { label: this.getOrderFieldLabel('carPrepayMoney', '预支/借支款金额'), value: 'carPrepayMoney' },
          { label: this.getOrderFieldLabel('driverBasealary', '主驾基本服务费'), value: 'driverBasealary' },
          { label: '预估利润', value: 'estimateProfitDouble' },
          { label: '实际利润', value: 'actualProfitDouble' },
        ]);
      } else {
        this.profitDetailItemList.push([
          { label: this.getOrderFieldLabel('carPrepayMoney', '预支/借支款金额'), value: 'carPrepayMoney' },
          { label: this.getOrderFieldLabel('driverBasealary', '主驾基本服务费'), value: 'driverBasealary' },
          { label: this.getOrderFieldLabel('coDriverBasealary', '副驾基本服务费'), value: 'coDriverBasealary' },
          { label: '预估利润', value: 'estimateProfitDouble' },
          { label: '实际利润', value: 'actualProfitDouble' },
        ]);
      }
      return profitDetail;
    },
    getEnclosureDetail (orderGoods) {
      return {
        contractUrl: orderGoods.contractUrl,
        // contractUrl: 'http://10.123.114.53/group1/M00/00/3B/CntyNV_8EOWAZHkpAAAePgVsdLA212_big.jpg?filename=66666666666.jpg',
      };
    },
    getOtherDetail (orderInfo) {
      return {
        remark: orderInfo.remark,
      };
    },
    isOrderPaymentWay (orderInfoExt) {
      return !!orderInfoExt && (orderInfoExt.paymentWayName === '订单模式' || Number(orderInfoExt.paymentWay) === 4);
    },
    getOrderFieldLabel (fieldName, fallbackLabel) {
      return this.orderFieldAliasMap[fieldName] || fallbackLabel;
    },
    syncChangefitDetail (detailRes) {
      const title = this.detailData.base.tableData.title;
      const currentIndex = title.findIndex((item) => item.prop === 'changefitDetail');
      if (currentIndex !== -1) {
        title.splice(currentIndex, 1);
      }
      if (!this.isOrderPaymentWay(detailRes.orderInfoExt) || !this.isShowChangefitDetail) {
        return;
      }
      const costIndex = title.findIndex((item) => item.prop === 'costDetail');
      const belongIndex = title.findIndex((item) => item.prop === 'belongDetail');
      const insertIndex = (costIndex !== -1 ? costIndex : belongIndex) + 1;
      title.splice(insertIndex, 0, {
        prop: 'changefitDetail',
        label: '预支/借支款费用审核',
        slot: true,
        span: 1,
      });
    },
    async getChangefitDetailParam (paymentWayName, paymentWay, tenantId) {
      this.orderFieldAliasMap = {};
      const cfgPaymentWayName = paymentWayName || (Number(paymentWay) === 4 ? '订单模式' : paymentWayName);
      const isOrderMent = await getOperInteCfgResultInfo({
        busiCode: '10010201',
        filedName: '成本模式',
        tenantId,
      });
      if (Number(paymentWay) !== 4) {
        return false;
      }
      // 当前订单是订单模式时，即使父级结果因响应包装差异没有被解析，
      // 也必须继续查询“订单模式”下的字段别名。
      const paymentWayConfig = isOrderMent.find((item) => `${item.value}` === `${paymentWay}`) || {};
      const paymentWayList = await getOperInteCfgResultInfo({
        busiCode: '10010201',
        filedName: paymentWayConfig.fieldName || cfgPaymentWayName || '订单模式',
        tenantId,
      });
      this.orderFieldAliasMap = paymentWayList.reduce((aliases, item) => {
        aliases[item.value] = item.fieldAlias || item.label || item.fieldName;
        return aliases;
      }, {});
      return paymentWayList.some((item) => item.value === 'carPrepayMoney');
    },
    isOilEnergy (detailRes, oilRes) {
      const energyType = detailRes && detailRes.energyType;
      if (energyType === 'A' || energyType === 'B') {
        return true;
      }
      if (energyType === 'E') {
        return false;
      }
      if (!oilRes || oilRes === '') {
        return true;
      }
      return oilRes.standardOilConsumptionDouble !== undefined || oilRes.actualOilConsumptionDouble !== undefined || oilRes.oilRiseDouble !== undefined;
    },
    async getData (detailRes) {
      detailRes.vehicleInfo = detailRes.vehicleInfo || await this.getCarInfo(detailRes.orderScheduler);
      this.isVerity = detailRes.isVerity;
      this.isShowChangefitDetail = await this.getChangefitDetailParam(
        detailRes.orderInfoExt.paymentWayName,
        detailRes.orderInfoExt.paymentWay,
        detailRes.vehicleInfo && detailRes.vehicleInfo.tenantId
      );

      let oilRes = '';
      if (detailRes.energyType === 'E') {
        oilRes = await getGasConsumptionByOrderId({
          orderId: this.orderId || this.$route.query.id,
        });
      } else if (detailRes.energyType === 'A' || detailRes.energyType === 'B') {
        oilRes = await getOilConsumptionByOrderId({
          orderId: this.orderId || this.$route.query.id,
        });
      }

      this.oilData = oilRes;

      // 详情数据
      this.orderDetail = {};

      // 1.1.3新增油耗上报需求，由于司机油/气耗费用可审核可修改，所以新写了接口，setBaseData传了原接口的detailRes以及新接口查询结果oilRes
      this.setBaseData(detailRes, oilRes);

      if (this.$route.query.type === 'approve' && detailRes && detailRes.orderInfo.orderUpdateState === 2) {
        // 重写各个模块的 审核数据
        this.setBaseVerData(detailRes);
      }
      this.detailRes = detailRes;
    },
  },
};
</script>


<style lang="scss" scoped>
.detail-item-inline-box {
  display: flex;
  justify-content: space-between;
  .detail-item-horizontal {
    // width: 33.3%;
    border-right: 1px solid #e0e0e0;
    padding: 0 8px 0 24px;
    &:first-child {
      padding-left: 0;
    }
    &:last-child {
      border-right: none;
    }
  }
}

.changeFitBox{
  background: #FAFAFA;
  border:1px solid #DCDFE6;
  text-align: center;
  width: 450px;
  display: inline-block;
  padding-left:15px;

  .td_1{
    height:30px;
    line-height: 40px;
    text-align: right;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .th_1{
    border-bottom:1px solid #DCDFE6;
  }
}
</style>


